import { j as o } from "../../_virtual/jsx-runtime.js";
const e = ({
  width: r = 20,
  height: t = 20,
  viewBox: s = "0 0 20 20",
  fill: n = "currentColor",
  ...H
}) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: t,
    viewBox: s,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...H,
    children: /* @__PURE__ */ o.jsx(
      "path",
      {
        d: "M5.83317 5V2.5C5.83317 2.03977 6.20627 1.66667 6.6665 1.66667H16.6665C17.1267 1.66667 17.4998 2.03977 17.4998 2.5V14.1667C17.4998 14.6269 17.1267 15 16.6665 15H14.1665V17.4993C14.1665 17.9599 13.7916 18.3333 13.3275 18.3333H3.33888C2.87549 18.3333 2.5 17.9628 2.5 17.4993L2.50217 5.83406C2.50225 5.37343 2.8772 5 3.34118 5H5.83317ZM4.16868 6.66667L4.16682 16.6667H12.4998V6.66667H4.16868ZM7.49983 5H14.1665V13.3333H15.8332V3.33334H7.49983V5Z",
        fill: n
      }
    )
  }
);
export {
  e as default
};
